"use client";

import { c as _c } from "react/compiler-runtime";
import dayjs from "dayjs";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";

/**
 * unbundling notice - Oracle jobs only — the SF jobs are not affected.
 * The same lists live in the legacy repo (jobhub-jobboard) for the boards that
 * have not been migrated yet. Keep them in sync.
 */
const COMPANIES = ["westenergie ag", "westenergie metering gmbh", "westenergie netzservice gmbh",
// Shortened to "AlfredThiel-Gedächtnis UK" in the ticket.
"alfred thiel-gedächtnis-unterstützungskasse gmbh"];

/** Second wave */
const COMPANIES_FROM_05_10 = ["avacon ag", "avacon connect gmbh", "avacon natur gmbh", "avacon netz gmbh", "bayernwerk ag", "bayernwerk natur gmbh", "bayernwerk netz gmbh", "e.dialog netz gmbh", "e.dis netz gmbh", "e.dis ag", "e.distherm energielösungen gmbh", "netz- und wartungsservice (nws) gmbh", "e.discom telekommunikation gmbh", "e.disnatur erneuerbare energien gmbh", "evailable gmbh", "energie-pensions-management gmbh", "eprimo gmbh", "hansegas gmbh", "hansewerk ag", "hansewerk natur gmbh",
// Both spellings: the company mapping carries "Schleswig-Holstein Netz",
// the Oracle data delivers "… GmbH".
"schleswig-holstein netz", "schleswig-holstein netz gmbh", "energiespeicher kraak gmbh", "preussenelektra gmbh", "rww mbh", "rww rheinisch-westfälische wasserwerksgesellschaft mbh"];

/** Third wave */
const COMPANIES_FROM_23_11 = ["westnetz gmbh", "westenergie aqua gmbh", "esk gmbh"];
function needsUnbundlingNotice(job: JobadComponentProps["job"]): boolean {
  if (!job.data.source?.startsWith("eon_oracle")) {
    return false;
  }
  const company = job.data.company.trim().toLowerCase();
  const now = dayjs();
  return COMPANIES.includes(company) || now.isAfter("2026-10-05T00:00+02:00") && COMPANIES_FROM_05_10.includes(company) || now.isAfter("2026-11-23T00:00+01:00") && COMPANIES_FROM_23_11.includes(company);
}
export default function UnbundlingNotice(t0) {
  const $ = _c(2);
  const {
    job
  } = t0;
  const t = useLanguage();
  if (!needsUnbundlingNotice(job)) {
    return null;
  }
  let t1;
  if ($[0] !== t.jobad_unbundling_text) {
    t1 = <p className="mt-4" data-source="lc">{t.jobad_unbundling_text}</p>;
    $[0] = t.jobad_unbundling_text;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}